// 用于代码混淆时可以压缩变量
var win = window;
// 代替 Object.assign, 避免兼容性
function assign(dist, src) {
    for (var key in src) {
        dist[key] = src[key];
    }
    return dist;
}
export default {
    setConfig: function (config) {
        if (!win.$watchDogConfig) {
            win.$watchDogConfig = {};
        }
        try {
            // 要保持原有的对象引用不变
            assign(win.$watchDogConfig, config);
        }
        catch (e) { }
    },
    sendEvent: function (eventName, field1, field2, field3, field4) {
        if (!win.$watchDogEvents) {
            win.$watchDogEvents = [];
        }
        try {
            win.$watchDogEvents.push([eventName, field1, field2, field3, field4]);
        }
        catch (e) { }
    },
};
